import * as api from './api'
import { ONE_HOUR } from '@/constants/time'
import { checkTtlDate } from '@/helper'
import { getLocalData, setLocalData } from '@/helper/localStorage'
import { ONLINE_ORDER } from '@/constants/localStorage'

export default {
  async loadData ({ commit }, { force = false } = {}) {
    const onlineOrderLocal = getLocalData(ONLINE_ORDER)
    const isNeedUpdate = checkTtlDate({
      timeUpdate: (onlineOrderLocal?.updateDate || 0),
      ttlTime: ONE_HOUR,
    })

    if (!force && onlineOrderLocal && !isNeedUpdate) {
      commit('setData', onlineOrderLocal.data)

      return { data: onlineOrderLocal.data }
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      commit('setData', data.data)

      setLocalData(ONLINE_ORDER, {
        updateDate: Date.now(),
        data: data.data
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async create ({ commit, state }, payload) {
    const { data } = await api.create(payload) || {}

    if (data?.code === 200) {
      const newData = state.data
      newData.unshift(data.data)

      commit('setData', newData)

      setLocalData(ONLINE_ORDER, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async change ({ commit, state }, payload) {
    const { id, data: payloadData } = payload || {}
    const { data } = await api.change(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            ...payloadData
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(ONLINE_ORDER, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async remove ({ commit, state }, payload) {
    const { data } = await api.remove(payload) || {}

    if (data?.code === 200) {
      const newData = state.data.filter(({ id }) => id !== payload )

      commit('setData', newData)

      setLocalData(ONLINE_ORDER, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  }
}